import { QBSActivityLogList } from '@exam-management/qbs-activity-log-list';
import { Flex, PaperSection } from '@shared/components';

export default function ActivityLogPage() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        width: '100%',
        p: theme.spacing(6),
      })}
    >
      <Flex>
        <PaperSection title='Activity Log'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              p: theme.spacing(6),
              gap: theme.spacing(6),
            })}
          >
            <QBSActivityLogList />
          </Flex>
        </PaperSection>
      </Flex>
    </Flex>
  );
}
